// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip_tooltip__tIirw {
  position: fixed;
  background: #222;
  color: #fff;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  max-width: 320px;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  word-wrap: break-word;
  transition: opacity var(--animation-duration-default), transform var(--animation-duration-default);
  animation: Tooltip_tooltipFadeIn__ppCnd var(--animation-duration-default) var(--cubic-bezier-default);
}
@supports (--color: red) {
  .Tooltip_tooltip__tIirw {
    background: var(--color-tooltip-bg, #222);
    color: var(--color-tooltip-text, #fff);
    box-shadow: 0 2px 8px var(--color-tooltip-shadow, rgba(0, 0, 0, 0.18));
  }
}

@keyframes Tooltip_tooltipFadeIn__ppCnd {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Tooltip/Tooltip.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,oBAAA;EACA,yCAAA;EACA,qBAAA;EACA,kGAAA;EACA,qGAAA;AACF;AAEE;EAhBF;IAiBI,yCAAA;IACA,sCAAA;IACA,sEAAA;EACF;AACF;;AAEA;EACE;IACE,UAAA;IACA,0BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF","sourcesContent":[".tooltip {\n  position: fixed;\n  background: #222;\n  color: #fff;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: .85rem;\n  max-width: 320px;\n  z-index: 9999;\n  pointer-events: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  word-wrap: break-word;\n  transition: opacity var(--animation-duration-default), transform var(--animation-duration-default);\n  animation: tooltipFadeIn var(--animation-duration-default) var(--cubic-bezier-default);\n  \n  // Use CSS variables to match project theme if they exist\n  @supports (--color: red) {\n    background: var(--color-tooltip-bg, #222);\n    color: var(--color-tooltip-text, #fff);\n    box-shadow: 0 2px 8px var(--color-tooltip-shadow, rgba(0, 0, 0, 0.18));\n  }\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `Tooltip_tooltip__tIirw`,
	"tooltipFadeIn": `Tooltip_tooltipFadeIn__ppCnd`
};
export default ___CSS_LOADER_EXPORT___;
